import { render, staticRenderFns } from "./dap-wizard-create.page.vue?vue&type=template&id=027f8f2c&scoped=true"
import script from "./dap-wizard-create.page.vue?vue&type=script&lang=ts"
export * from "./dap-wizard-create.page.vue?vue&type=script&lang=ts"
import style0 from "./dap-wizard-create.page.vue?vue&type=style&index=0&id=027f8f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f8f2c",
  null
  
)

export default component.exports